(() => {
  if (window.__a2lBreadcrumbContext) return;
  window.__a2lBreadcrumbContext = true;
  const config = document.querySelector('script[data-a2l-path-context]');
  if (!config) return;
  const namespace = 'p3d:product-entry:';
  const clean = (text) => String(text || '').replace(/\s+/g, ' ').trim().slice(0, 180);
  const url = (value) => {
    try {
      const parsed = new URL(value, location.href);
      if (parsed.origin !== location.origin || !/^https?:$/.test(parsed.protocol)) return null;
      ['preview_theme_id', '_fd', 'pb', 'preview_key'].forEach((key) => parsed.searchParams.delete(key));
      return parsed.pathname + parsed.search + parsed.hash;
    } catch { return null; }
  };
  const productKey = (value) => String(value || '').match(/\/products\/([^/?#]+)/)?.[1] || '';
  const read = (key) => { try { return JSON.parse(sessionStorage.getItem(namespace + key)); } catch { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(namespace + key, JSON.stringify(value)); } catch { /* Browsing works without storage. */ } };
  const home = { label: 'Inicio', url: url(config.dataset.rootUrl || '/') || '/' };
  const currentPage = {
    label: clean(document.querySelector('#MainContent h1')?.textContent || config.dataset.pageTitle),
    url: url(location.href),
    type: config.dataset.pageType,
    time: Date.now()
  };
  const previousPage = read('last-page');

  const sourceTrail = (link) => {
    const trail = [home];
    const menu = link.closest('[data-header-nav-url][data-header-nav-label]');
    if (menu) {
      const href = url(menu.dataset.headerNavUrl);
      const label = clean(menu.dataset.headerNavLabel);
      if (href && href !== home.url && label) trail.push({ label, url: href });
      const panel = link.closest('[data-p3d-category-panel]');
      const category = panel && menu.querySelector(`[aria-controls="${CSS.escape(panel.id)}"]`);
      if (category && clean(category.textContent)) trail.push({ label: clean(category.textContent) });
      return trail;
    }
    if (currentPage.type !== 'index' && currentPage.label && currentPage.url !== home.url) trail.push({ label: currentPage.label, url: url(location.href) });
    if (currentPage.type === 'index') {
      const section = link.closest('#MainContent > .shopify-section');
      const heading = section?.querySelector('h2');
      if (heading && section.id) trail.push({ label: clean(heading.textContent), url: home.url.split('#')[0] + '#' + section.id });
    }
    return trail;
  };

  const capture = (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || link.hasAttribute('download')) return;
    const target = url(link.href);
    const key = productKey(target);
    if (!key) return;
    write(key, { target, trail: sourceTrail(link), from: url(location.href), time: Date.now(), pending: true });
    write('last-page', { ...currentPage, url: url(location.href) });
  };
  document.addEventListener('click', capture, true);
  document.addEventListener('auxclick', capture, true);

  const render = (nav, fromCache = false) => {
    const list = nav.querySelector('ol');
    const first = list?.firstElementChild?.querySelector('a');
    const current = list?.querySelector('[aria-current="page"]');
    if (!first || !current) return;
    const currentTitle = current.textContent;
    const arrow = current.parentElement.querySelector('svg')?.cloneNode(true);
    const key = productKey(nav.dataset.productUrl || location.pathname);
    const entry = read(key);
    const referrer = url(document.referrer);
    const navigation = performance.getEntriesByType('navigation')[0]?.type;
    const restored = fromCache || navigation === 'reload' || navigation === 'back_forward';
    const valid = entry && Date.now() - entry.time < 86400000 && (
      restored || (entry.pending && Date.now() - entry.time < 300000 && (!document.referrer || referrer?.split('#')[0] === entry.from?.split('#')[0]))
    );
    let trail = [{ label: first.textContent, url: url(first.href) || home.url }];
    if (valid) {
      trail = entry.trail.map((item, index) => index === 0 ? trail[0] : item);
      entry.pending = false;
      write(key, entry);
    } else if (nav.dataset.collectionUrl && nav.dataset.collectionLabel) {
      if (!restored) write(key, null);
      trail.push({ label: nav.dataset.collectionLabel, url: url(nav.dataset.collectionUrl) });
    } else if (referrer && previousPage && url(previousPage.url)?.split('#')[0] === referrer.split('#')[0] && previousPage.type !== 'index' && previousPage.label) {
      if (!restored) write(key, null);
      trail.push(previousPage);
    } else if (!restored) {
      write(key, null);
    }
    const seen = new Set();
    trail = trail.filter((item) => {
      const marker = item.url || clean(item.label);
      if (!clean(item.label) || seen.has(marker) || productKey(item.url) === key) return false;
      seen.add(marker);
      return true;
    }).slice(-4);
    const fragment = document.createDocumentFragment();
    [...trail, { label: currentTitle, current: true }].forEach((item, index) => {
      const li = document.createElement('li');
      if (index && arrow) li.append(arrow.cloneNode(true));
      const href = !item.current && item.url ? url(item.url) : null;
      const text = document.createElement(href ? 'a' : 'span');
      text.textContent = clean(item.label);
      if (href) text.href = href;
      if (item.current) { text.className = 'a2l-breadcrumb__current'; text.setAttribute('aria-current', 'page'); }
      li.append(text);
      fragment.append(li);
    });
    list.replaceChildren(fragment);
  };
  document.querySelectorAll('[data-a2l-breadcrumb]').forEach((nav) => render(nav));
  document.addEventListener('shopify:section:load', (event) => event.target.querySelectorAll('[data-a2l-breadcrumb]').forEach((nav) => render(nav, true)));
  window.addEventListener('pageshow', (event) => { if (event.persisted) document.querySelectorAll('[data-a2l-breadcrumb]').forEach((nav) => render(nav, true)); });
  write('last-page', currentPage);
})();
